import { render, staticRenderFns } from "./index.vue?vue&type=template&id=42aa580d&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AcademyHomepage: require('/home/smiley/3df/components/AcademyHomepage.vue').default,Homepage: require('/home/smiley/3df/components/Homepage.vue').default})
